// oxlint-disable require-await
import {dialog} from '@cypro/ui/components'
import {DeleteResourceDialog} from '@cypro/ui/components'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {DeleteResourceSchema} from '@cypro/engine/mutators'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useDeleteTradeName() {
  const zero = useZero()

  return useCallback(
    async (payload: DeleteResourceSchema) =>
      zero.attemptMutation(zero.mutators.tradeNames.delete(payload), async ({server}) => {
        const result = await server
        return result
      }),
    [zero]
  )
}

export function useConfirmDeleteTradeName() {
  const {t: tTradeNames} = useTranslate('trade-names')
  const deleteTradeName = useDeleteTradeName()

  return useCallback(
    async (payload: DeleteResourceSchema) => {
      const confirmed = await dialog.open(payload.id, {
        children: (
          <DeleteResourceDialog
            id={payload.id}
            title={tTradeNames('delete_trade_name_dialog.title')}
            description={tTradeNames('delete_trade_name_dialog.description')}
          />
        ),
      })
      if (!confirmed) throw new Error('User did not confirm')

      const deleteRes = await deleteTradeName(payload)
      if (!deleteRes) throw new Error('Unknown error')
      if (deleteRes.type === 'error') throw deleteRes.error
    },
    [tTradeNames, deleteTradeName]
  )
}
